// extracted by mini-css-extract-plugin
export default {"return":"components_return__NVydS","input":"components_input__t7HL5","more":"components_more__i8vc9"};